import axios from 'axios'
import { Toast } from 'mint-ui'
import router from '../router'
import wx from 'weixin-js-sdk';
const version = 'v2.8.8';

axios.interceptors.request.use(function (request) {       
    
    request.headers['authorization'] = window.localStorage.getItem('userInfo') != null?JSON.parse(window.localStorage.getItem('userInfo')).token:'';
    if (request.method === 'post') {
        request.data = JSON.stringify(request.data);
        request.headers['Content-Type'] = 'application/json;charset=UTF-8';
        request.headers['authorization'] = sessionStorage.getItem('token');
        request.headers['version'] =  process.env.API_VERSION;
    }
    // Toast(request.headers.authorization)
    return request
}, err => {
    return Promise.reject(err)
})
axios.interceptors.response.use(function (response) {
    console.log(response);
    let data = typeof response.data === 'string' ? {data: {text: response.data}, code: 200} : response.data
    if (response.status === 200 && (data.status === 0 || data.status === '0' || data.status === 10 || data.code === 200 || !data.status)) {     
            
            // && (typeof data === 'object' ? data : JSON.parse(data))  
                data = data.data || data
                return data       
            
    }else {     
        let msg = response.data.msg || response.data.message
        console.log(response.config.url.includes('know/question/addQuestionAnwser'),'response.config.url.includ');
        if (data.status === 1 && data.code != 'REQ001'&&data.code != 'SEN001' && (response.config.url.includes('know/question/addQuestionAnwser') || response.config.url.includes('know/answer/addAnswerComment'))){
            Toast(msg)
        }
        console.log("报错",data);
        let mpWeixin = false
        wx.miniProgram.getEnv(function(res) {
            console.log(res.miniprogram) // true
            mpWeixin = res.miniprogram
        })
        if(data.status === 1 && data.code == 'SEN001'){            
            let u = navigator.userAgent;
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1            
            if(isiOS){
                window.JXBJSBridge.call({
                    target: "WKFunction",
                    action: "isLogin",
                    data: {},
                    callback: {
                    }
                });                
                // window.webkit.messageHandlers.isLogin.postMessage({});
            }else{            
                if(window.Android && window.Android.isLogin){
                    window.Android.isLogin();
                }else if(window.isLogin){
                    window.isLogin.jsMethod({});
                }else if(mpWeixin){
                    wx.miniProgram.reLaunch({
                        url: `/pages/login/index`
                    })
                }
            }
            // if(router.history.current.path !== '/userCenter/home'){
            //     router.push({ name: "login" })
            // }
        }else{
            // 一切不是未登录的报错，全部跳转到studymobile登陆页面      
            if (data.msg && data.msg.indexOf('系统账号输入错误，请重新输入您的系统账号（比如') !== -1) {
                // crm情况
            } else {
                let u = navigator.userAgent;
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if(location.href.indexOf('articleOuter') > -1){//外部通用文章除外
                    console.log("不跳转");
                }else if(mpWeixin || isiOS || window.Android){ //小程序、APP除外
                    console.log("不跳转");
                }else{

                    window.location.href = `${process.env.API_ROOT}mobile`
                }
                // if (location.href.indexOf('articleOuter') === -1 || !mpWeixin) { // 外部通用文章除外\


                // }
            }

        }
        //  if (data.status !== 1) {
        //     Toast(msg)
        // }
        // return Promise.reject(response.data)
    }
    }, err => {
    return Promise.reject(err)
})

// 上传文件
const uploadFile = (option) => {
    return new Promise((resolve, reject) => {
      var axios_instance = axios.create({
        // transformRequest: [function (data) {
        //   return data;
        // }],
        headers: {
          'Content-Type': 'multipart/form-data',
          "authorization" : sessionStorage.getItem("token") || '',
          'version':process.env.API_VERSION
        },
      });
  
      // let _data = Object.assign({},option.data,commonFuc.getSafeObj())
  
      axios_instance.post(option.url, option.data).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }

  export { uploadFile }


// WEBPACK FOOTER //
// ./src/api/index.js